import { render, staticRenderFns } from "./AirtableSubscribe.vue?vue&type=template&id=bf1fd662&scoped=true"
import script from "./AirtableSubscribe.vue?vue&type=script&lang=js"
export * from "./AirtableSubscribe.vue?vue&type=script&lang=js"
import style0 from "./AirtableSubscribe.vue?vue&type=style&index=0&id=bf1fd662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1fd662",
  null
  
)

export default component.exports